export function initAccountData(account) {
  return {
    account: account,
    isAccountError: false
  }
}